// Pac-Man eats one $ per listed item; when the lister finishes the batch he eats the SnapList logo.
export default function ListerProgress({ listed, total, name, testid }) {
  const done = total > 0 && listed >= total;
  const pct = total ? Math.min(100, (listed / total) * 100) : 0;
  const dots = Math.min(total, 12);
  return (
    <span className="mt-1.5 block" data-testid={testid}>
      <span className="flex items-center justify-between text-[10px] font-semibold">
        <span className="text-slate-500">{name ? `${name}` : "Lister"}: <b className="font-mono text-slate-800" data-testid={`${testid}-count`}>{listed} of {total}</b> listed</span>
        {done && <span className="lp-done text-emerald-700" data-testid={`${testid}-done`}>All listed!</span>}
      </span>
      <span className={`lp-track ${done ? "lp-complete" : ""}`} style={{ "--pm": "14px" }} aria-hidden="true">
        {Array.from({ length: dots }, (_, i) => {
          const at = ((i + 1) / (dots + 1)) * 100;
          return <span key={i} className={`lp-dollar ${at <= pct ? "lp-eaten" : ""}`} style={{ left: `${at}%` }}>$</span>;
        })}
        <span className="lp-logo">SL</span>
        <span className="lp-man pm-man" style={{ left: `calc(${done ? 100 : pct}% - ${done ? 16 : pct ? 7 : 0}px)` }}>
          <span className="pm-jaw pm-top" /><span className="pm-jaw pm-bottom" />
        </span>
      </span>
    </span>
  );
}
